import { useContext, useEffect, useRef } from "react";
import globalStates from "../../utils/global";
import "./ShopScreen1alt.css"
import {  ImgShopScreen1, ImgStoryScreen1d } from "../../assets";

const ShopScreen1alt = () =>{

    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    
    // const businessDetailImagesImg = businessDetailImages && businessDetailImages.screenBannerImg;

    const screenShopScreen1alt = useRef(null) as any;
    // console.log({})
    useEffect(()=>{
        const handleScroll =()=>{
            const setScreensOffset = globalContext && globalContext.setScreensOffset;
            const screenWebsite = screenShopScreen1alt.current.getBoundingClientRect();
            const top = screenWebsite.top;
            const bottom = screenWebsite.bottom;
            const offset = globalContext && globalContext.windowHeight;
            setScreensOffset((prev:any)=>{return {...prev, 
                isOffsetscreenWebsite: false, bottom, offset, top
            }});
            if(top < (-1*0.005*offset) ){
                setScreensOffset((prev:any)=>{return {...prev, bottom, offset, top,
                    isOffsetscreenWebsite: true,
                }});
            };
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [globalContext])

    const componentData = {
        background: {
            image: {
                src: ImgShopScreen1,
                alt: ""
            }
        },
        shield: {

        },
        content: {
            left: {
                title: "KUNO SHOP"
            },
            right: {
                desc: ""
            }
        }
    }
    
    return(
        <>
            <div 
            ref={screenShopScreen1alt} 
            className={`${windowWidthClass}-shop-screen-1-alt wrapper`}>

                <div className="background">
                    <div className="frame">
                        <img
                            alt = {componentData.background.image.alt}
                            src = {componentData.background.image.src}
                        />
                    </div>
                </div>
                <div className="shield">

                </div>
                <div className="content display grid">
                    <div className="text-wrapper left">
                        <h1>{componentData.content.left.title}</h1>
                    </div>
                    <div className="text-wrapper right">
                        {/* <p>{componentData.content.right.desc}</p> */}
                    </div>
                    
                </div>

            </div>
        </>
        
    )
};

export default ShopScreen1alt;